import React from 'react';

const VerseDisplay = ({ currentVerse, selectedTranslations }) => {
  if (!currentVerse) return <p>No verse selected</p>;

  // Create color palette for researchers
  const colors = [
    '#007bff', '#28a745', '#dc3545', '#ffc107', '#17a2b8',
    '#6f42c1', '#e83e8c', '#fd7e14', '#20c997', '#6610f2',
    '#d63384', '#0d6efd', '#198754', '#ff0000', '#00ff00',
    '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#800000'
  ];

  // Create researcher to color mapping (sorted alphabetically for consistency)
  const allResearchers = [...new Set((currentVerse.translations || []).map(t => t.researcher_name))].sort();
  const researcherToColor = {};
  allResearchers.forEach((name, idx) => {
    researcherToColor[name] = colors[idx % colors.length];
  });

  return (
    <div style={{ width: '60%', padding: '0 10px' }}>
      <p><strong>Page Number:</strong> {currentVerse.page_number}</p>
      <p><strong>Line Number:</strong> {currentVerse.line_number}</p>
      <p><strong>Verse Number:</strong> {currentVerse.verse_number}</p>
      <p><strong>Phrase:</strong> {currentVerse.line_text}</p>
      {currentVerse.translations && selectedTranslations.length > 0 && (
        <div>
          <strong>Translations:</strong>
          <ul style={{ textAlign: 'left' }}>
            {currentVerse.translations
              .filter(t => selectedTranslations.includes(t.researcher_name))
              .map((translation, idx) => (
                <li key={idx} style={{ textAlign: 'left', fontSize: '14px' }}>
                  <strong>
                    <span style={{ 
                      display: 'inline-block', 
                      width: '12px', 
                      height: '12px', 
                      borderRadius: '50%', 
                      backgroundColor: researcherToColor[translation.researcher_name],
                      marginRight: '6px',
                      verticalAlign: 'middle'
                    }}></span>
                    {translation.researcher_name}:
                  </strong> {translation.translation_text}
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default VerseDisplay;
